import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, NgForm, ValidatorFn, EmailValidator, Validators } from '@angular/forms';
import { LoadJsService } from '../../load-js/load-js.service';
import { URLSearchParams } from '@angular/http';
import swal from 'sweetalert/dist/sweetalert.min.js';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./playbox.component.css']
})
export class MessageComponent implements OnInit {
  
  @ViewChild("fileUploader", { static: false })
  fileUploader: ElementRef;
  @ViewChild("fileReupload", { static: false })
  fileReupload: ElementRef;
  
  @ViewChild("target", { static: false })

  @ViewChild('closeBtn', { static: false }) closeBtn: ElementRef;

  textSearch = new FormControl(''); 
  
  msearch : string;
  customercategory:string;
  custcat:string;
  messagetype:string;
  limit = 10;
  multiple : any = [];
  multiple_string = '';

  listws : any = [];

  //pagination
  paging_link : any = [];
  paging : any = {};
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';
  //end pagination
  bulkdescription= 'Hai Sobat Play ID {ACCOUNT_ID}, tagihan per {DATE} sebesar Rp. {AMOUNT} telah dikirim ke email kamu. Lakukan pembayaran tepat waktu agar kamu terhindar dari Biaya Pengaktifan Ulang. Info Hub 021 3001-4121/0811-1014-121';
  
  totallist = 0;  
  totaltodolist = 0;  
  countdown = 0;
  countsuccess = 0;
  countfailed = 0;
  donelist = [];

  msggroup = '';
  msgtype = '';
  title = '';

  formSet = this.fb.group({
    messagetype: [''],
    messagegroupid:[''],
    customerid: [''],
    customercategoryid: [''],
    multiple_customer: [''],
    title: [''],
    description: [''],
    img: [''],
    publishdate: [''],
    customerstype: [''],
  })

  falsemessage:any = '';

  listmessage:any = []
  listcust:any = []
  listcustdata:any = []
  messagedetail:any = []
  listcustcategory:any = []
  listmessagetype:any = []
  listmessagegroup:any = []
  alert_act: any = []
  alert_act2: any = []
  showntypex: any = []
  itemset: any = {}
  custidadd: any = {}

  table_load = true

  message : string
  custname : string
  lengthcust : number
  confirmation = false
  custidvalue = false
  custidinput = false


  constructor(
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public LoadJs: LoadJsService,
    private router: Router
  ) { }

  ngOnInit() {
    this.loadStart()
  }
  
  loadStart() {
    this.listmessagegroup = [{id:1,name:"Message"},{id:2,name:"Runningtext"},{id:3,name:"OSD"}];  
    this.route.queryParams
      .subscribe(params => {

        //this.order = params.order;
        //console.log(this.order); // popular

        if ((params.search != '' || params.customercategory != ''  || params.messagetype != '') && params.search != undefined ){
          // console.log('search');
          // console.log(params.search);
          this.msearch = params.search 
          this.customercategory = params.customercategory;
          this.messagetype = params.messagetype;
          this.querySearch = true
        

          this.currentParams = params;
          this.queryParams = '?'+this.queryStr(params)
          this.loadListmessage(this.queryParams)
        
        }else{
          this.querySearch = false;
          this.currentParams = params

          this.queryParams = '?'+this.queryStr(params)
          this.loadListmessage(this.queryParams)
        }
      });

      this.clearForm()
      this.loadcustcategory()
      this.loadmessagetype()
      this.msearch = undefined
      this.customercategory = undefined
      this.messagetype = undefined
    
  }
  
  refreshPage() {
    this.ngOnInit()
  }

  search()
  {
    this.querySearch = true

    if ( this.msearch == undefined){
      this.msearch = ''
    }
    if ( this.messagetype == undefined ){
      this.messagetype =  'All'
    }
    if ( this.limit != undefined ){
      this.searchQueryParams += '&limit='+this.limit
    }

    if ( this.customercategory == undefined ){
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msearch+'&customercategory=All'+'&messagetype='+this.messagetype
    }else{
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msearch+'&customercategory='+this.customercategory+'&messagetype='+this.messagetype
    }
    
    this.loadListmessage(this.searchQueryParams)
  }

  queryStr(options: any){
    let params = new URLSearchParams()
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString()
  }

  queryStrSearch()
  {
    if ( this.msearch ){
      return '&search='+this.msearch
    }else{
      return ''
    }
  }

  clearForm() {
    this.formSet.reset()
    this.custidvalue = false
    this.custidinput = false
    this.formSet.get('customercategoryid').setValue(undefined)
    this.formSet.get('messagetype').setValue(undefined)
    this.formSet.get('messagegroupid').setValue(undefined)
    this.formSet.get('customerstype').setValue(undefined)
    this.listcustdata = []
    this.custidadd = 100
  }

  onActionClick(act:any, item: any) {
    this.alert_act = act

    if(this.alert_act == 'add'){
      this.clearForm()
    }
    if(this.alert_act == 'view'){
      this.itemset = item
      this.loadmessagedetail(item.id)
    }
  }
  onChangebtn(act2:any, e: any) {
    this.alert_act2 = act2

    if(this.alert_act2 == 'msgtype'){
      console.log(e.target.value)
      if(e.target.value == 1){
        this.custidadd = 100;
        //this.custidadd = {}
        this.custidvalue = true
        this.custidinput = true
        this.formSet.get('customerid').setValue(null)
        this.formSet.get('customercategoryid').setValue(undefined)

      }else if(e.target.value == 2){
        this.custidadd = 100;
        //this.custidadd = {}
        this.custidvalue = true
        this.custidinput = true
        this.formSet.get('customerid').setValue(null)
        this.formSet.get('customercategoryid').setValue(undefined)

      }else if(e.target.value == 3){
        this.custidadd = 100;
        //this.custidadd = {}
        this.custidvalue = true
        this.custidinput = true
        this.formSet.get('customerid').setValue(null)
        this.formSet.get('customercategoryid').setValue(undefined)

      }else{
        this.custidadd = {}
        this.listcustdata = []
        this.custidvalue = false
        this.custidinput = false
        this.formSet.get('customerid').setValue('All')
        this.formSet.get('customercategoryid').setValue(undefined)

      }
    }
  }
  onLength(){
    this.listcustdata = []
    this.custidadd = 100
    let item = this.formSet.get('customerid').value
    if(item.length >= 4){
      this.loadlistcust(item)
      this.lengthcust = 4 - item.length
      this.custidinput = true
      // console.log(this.lengthcust, item.length)
    }else{
      this.lengthcust = 4 - item.length
      this.custidinput = false
      // console.log(this.lengthcust, item.length)
    }
  }

  onMultiple()
  {
    
    this.multiple = this.formSet.value.multiple_customer.split(',');
    console.log(this.formSet.value.multiple_customer.split(','));
  }

  pushcust(){
    
    this.multiple.push(this.custidadd.id);

    this.formSet.get('multiple_customer').setValue(this.multiple.toString());
    

    // for (let i = 0; i < this.multiple.length; i++) {
    //   // console.log(multipel[i]);
    //     // this.formSet.get('multiple_customer').setValue(this.multiple.split(','));
    //   this.formSet.get('multiple_customer').setValue(this.multiple)
    // }

    // if(this.formSet.get('multiple_customer'))
    // {s
      
    // }
  

    console.log(this.multiple.toString())
    // console.log(this.custidadd)
    this.formSet.get('customerid').setValue(this.custidadd.id)
    this.formSet.get('customercategoryid').setValue(this.custidadd.customercategoryid)
  }

  onConfirm(){
    swal({
      title: "Yakin?",
      icon: "info", 
      buttons: ["Tidak", "IYALAH!!!"],
    }).then((confirm) => {
      if (confirm) {
        swal(this.formSet.get('title').value +" is successfully saved.", 
        {
          icon: "sucess", 
        });
        this.ngOnInit()
      } else {
        swal("Huffff");
      }
    });
  }

  private closeModal(): void {
    this.closeBtn.nativeElement.click();
  }
  alertsx(message:any){
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
    });
    setTimeout(()=>{
      this.closeModal()
      this.ngOnInit()
    }, 1000);
  }
  alertfx(message:any){
    swal({
      title: "Gagal!",
      text: message,
      icon: "error",
    });
    
  }

  loadlistcust(item:any){
    let data = { "search": item}
    console.log(data);
    return this.partnerService.Listcustomermessage(data).subscribe((output: any) => {
        this.listcust = output.data

        this.listcust.forEach((row:any) => {
          this.listcustdata.push(row)
        })
        
    })
  }

  loadListmessage(params: any) {
    this.table_load = true

    return this.partnerService.Getlistmessage(params).subscribe((output: any) => {
    // console.log(output)
      this.listmessage = output.data

      this.table_load = false

      this.paging = output.pagex;
      this.page_self = output.pagex.self
      this.page_next = output.pagex.next
      this.page_prev = output.pagex.prev
      this.meta = output.meta
      this.total_count = this.meta['totalCount']
      let self = this.page_self['page']
      if ( self * this.meta['perPage'] < this.meta['totalCount']){
        this.last_index = (self * this.meta['perPage'])
      }else{
        this.last_index = this.meta['totalCount']
      }
      this.first_index = ((self-1)*this.meta['perPage'])+1

    })
  }

  loadmessagedetail(id:any){
    this.partnerService.Getmessagedetail(id).subscribe((output: any) => { 
      this.messagedetail = output.data

      this.formSet.get('messagegroupid').setValue(this.messagedetail.messagegroupid)
      this.formSet.get('messagetype').setValue(this.messagedetail.messagetype)
      this.formSet.get('customerid').setValue(this.messagedetail.customerid)
      this.formSet.get('customercategoryid').setValue(this.messagedetail.customercategoryid)
      this.formSet.get('title').setValue(this.messagedetail.title)
      this.formSet.get('description').setValue(this.messagedetail.description)
      this.formSet.get('img').setValue(this.messagedetail.img)
      this.formSet.get('publishdate').setValue(this.messagedetail.publishdate)
      this.formSet.get('customerstype').setValue(this.messagedetail.ftth)
      this.custname = this.messagedetail.customername

    }); 
  }

  loadcustcategory() {
    this.partnerService.Getcustcategory().subscribe((output: any) => { 
      this.listcustcategory = output.data
    });  
  }
  loadmessagetype() {
    this.partnerService.Getmessagetype().subscribe((output: any) => { 
      this.listmessagetype = output.data
    })
  }

  public setCountdown(count){
    this.countdown = count;
  }

  submitAddBulk() {

     for (let i = 0; i < this.listws.length; i++) {
     
      let datas = this.listws[i];
      
      let dates = datas['date_tampil'].split('/');
      console.log(dates);

      let input = {ftth:1,customerid: datas.account_id,
        publishdate: {year:dates[2],month:dates[1],day:dates[0]},
        customercategoryid:1,
        messagegroupid:this.msggroup,
        messagetype:this.msgtype,
        title: this.title,
        description: this.renderthem(datas)};
        console.log(input);
      
       this.partnerService.Addmessage(input)
        .subscribe((output: any) => { 

            this.totaltodolist--; 
            
            
            if ( output.status ){
              this.countsuccess++;
              datas['statusex'] = true;
              datas['message'] = output.data.message;

            }else{
              this.countfailed++;
              datas['statusex'] = false;
              datas['message'] = output.data.message;
            }
            
            this.donelist.push(datas);

            this.setCountdown(this.totaltodolist);
             
         });
      //console.log(this.formSet.value.customerid);
    }


  }

  submitAdd() {
    
    if(this.formSet.value.customercategoryid == undefined){
      this.formSet.get('customercategoryid').setValue(100)
    }

    console.log(this.formSet.value)
    this.falsemessage = ''
    for (let i = 0; i < this.multiple.length; i++) {
      this.formSet.get('customerid').setValue(this.multiple[i]);

    
     this.partnerService.Addmessage(this.formSet.value)
      .subscribe((output: any) => { 
        if(output){
          if (output.status == true) {
            
            this.message = output.message
            this.alertsx(this.message)
            this.multiple = [];
            
          } else {
            this.falsemessage = this.falsemessage + this.multiple[i] + ','
            this.message = output.message
            this.alertfx(this.message)
          }
        }else{
          this.alertfx("Error hit API")
        }
    })
      console.log(this.formSet.value.customerid);
    }

   
  }
  submitSet() {
    let id = this.itemset.id
    // console.log(id, this.formSet.value)
    
    this.partnerService.Setmessage(id, this.formSet.value)
      .subscribe((output: any) => { 
        if (output.status == true) {

          this.message = output.message
          this.alertsx(this.message)

        } else {

          this.message = output.message
          this.alertfx(this.message)

        }
    })
  }
  submitDelete() {
    let id = this.itemset.id

    swal({
      title: "Are you sure?",
      text: '"'+this.itemset.title+'" Akan dihapus',
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        // console.log(id,this.itemset)
        this.partnerService.Deletemessage(id)
          .subscribe((output: any) => { 
            if (output.status == true) {

              this.message = output.message
              this.alertsx(this.message)

            } else {

              this.message = output.message
              this.alertfx(this.message)

            }
        })
        
      } 
      // else {
      //   swal('"'+this.itemset.title+'" Batal dihapus');
      // }
    });
    
  }

  processFile(event : any) {
    // console.log('masuk')
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(event.target);
    
    this.listws = [];

    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});
      /* first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      console.log(XLSX.utils.sheet_to_json(ws, {header:0}));
     // var arr = Object.keys(ws).map(key => ({type: key, value: ws[key]}));
     this.listws = XLSX.utils.sheet_to_json(ws, {header:0});

     this.totallist = this.listws.length;
     this.totaltodolist = this.listws.length;
     this.countdown = this.totaltodolist;
     //console.log(this.totallist);
     // console.log(arr);

      /* save data */
      //this.formOrderUpload.get('value_upload').setValue(XLSX.utils.sheet_to_json(ws, {header:0}));
      //this.formOrderReupload.get('value_upload').setValue(XLSX.utils.sheet_to_json(ws, {header:0}));
      // console.log(this.formValidasiOrder.value)
      
    };
    reader.readAsBinaryString(target.files[0]);
  }

  renderthem(item){
    //let str = 'Hai Sobat Play ID {ACCOUNT_ID}, tagihan per {DATE} sebesar Rp. {AMOUNT} telah dikirim ke email kamu. Lakukan pembayaran tepat waktu agar kamu terhindar dari Biaya Pengaktifan Ulang. Info Hub 021 3001-4121/0811-1014-121';
    let str = this.bulkdescription;
    var re = /{ACCOUNT_ID}/gi;
    str = str.replace(re, item.account_id); 
    str = str.replace(/{DATE}/gi, item.date); 
    return str.replace(/{AMOUNT}/gi, item.amount); 

  }

}

